import { NgModule } from "@angular/core";

import { CodeEditorModule } from "@acrodata/code-editor";

import { TextEditorsCoreModule } from "../text-editors-core.module";
import { SqlEditorComponent } from "./components/sql-editor.component";
import { SqlEditorThemeService } from "./services/sql-editor-theme.service";
import { SqlEditorLanguageService } from "./services/sql-editor-language.service";
import { SqlEditorCompletionService } from "./services/sql-editor-completion.service";
import { SqlEditorSchemaVisitorService } from "./services/sql-editor-schema-visitor.service";
import { SqlEditorLanguageConfigService } from "./services/sql-editor-language-config.service";
import { SqlEditorLanguageDialectService } from "./services/sql-editor-language-dialect.service";
import { SqlEditorSchemaCompletionService } from "./services/sql-editor-completion-schema.service";
import { SqlEditorKeywordCompletionService } from "./services/sql-editor-completion-keyboard.service";
import { SqlEditorVariableCompletionService } from "./services/sql-editor-completion-variable.service";


@NgModule({
    declarations: [
        SqlEditorComponent
    ],
    providers: [
        SqlEditorVariableCompletionService,
        SqlEditorKeywordCompletionService,
        SqlEditorSchemaCompletionService,
        SqlEditorLanguageDialectService,
        SqlEditorLanguageConfigService,
        SqlEditorSchemaVisitorService,
        SqlEditorCompletionService,
        SqlEditorLanguageService,
        SqlEditorThemeService,
    ],
    exports: [
        SqlEditorComponent,
    ],
    imports: [
        TextEditorsCoreModule,
        CodeEditorModule,
    ]
})
export class SqlEditorModule {
}